import {SpAlert} from "../../../components/sp-alert/sp-alert.model";

export class Controller {

    /** @ngInject */
    constructor($state, Alert, ResetPasswordService,$stateParams) {
    	this.$stateParams=$stateParams;
        this.$state = $state;
        this.Alert = Alert;
        this.ResetPasswordService = ResetPasswordService;
    }

    $onInit() {
        this.user={};
    }

    goBack() {
        this.$state.go('public.login-web-saml',{applicationId:this.$state.params.appKey,SAMLTracker: this.$state.params.SAMLTracker,appName:this.$state.params.appName,appType:this.$state.params.appType,icon:this.$state.params.icon,loginWithPassword:true});
    }


    save() {
        this.ResetPasswordService.sendResetEmail(this.$state.params.appKey,this.user.username,this.user.email)
            .then(()=>{this.Alert('success', 'Instructions to reset your password has been sent to the email',false)})
    }


}



// WEBPACK FOOTER //
// ./src/portal/states/public/reset-password/reset-password.controller.js